export default {
  'enabled-locations-map': {
    locations: 'Emplacements',
    'find-my-location': 'Trouver mon emplacement',
    'select-country': 'Sélectionner le pays',
    'all-countries': 'Tous les pays',
    search: 'Rechercher',
    filter: 'Filtrer par fournisseur, ville, pays ou état',
    'location-type': 'Catégorie d’emplacement',
    '100G-enabled': 'Compatible 100G',
    'local-ix-available': 'IX local disponible',
    'mcr-enabled': 'MCR-Compatible',
    'mve-enabled': 'MVE-Compatible',
    'view-latency': 'Voir la latence',
    'enquire-about-this-location': 'Demander des informations sur cet emplacement',
    'enabled-location': 'Emplacement activé',
    'extended-location': 'Emplacement étendu',
    'loading-locations': 'Chargement des emplacements',
    'no-location-found': 'Aucun emplacement ne satisfait aux critères de filtrage',
    'closest-mp-enabled-location': 'Le site Megaport Activé le plus proche est',
    'location-filter': 'Filtre de localisation',
    'coming-soon': 'Bientôt disponible',
    'enter-your-address': 'Entrez votre adresse',
    'learn-about-enabled-extended-locations': 'En savoir plus sur nos Emplacements Activés et Étendus',
    'megaport-supported-location-types': `Megaport prend en charge deux types d'emplacements où vous pouvez accéder à notre réseau`,
    'locations-by-distance': 'Emplacements par distance',
    'map-showing-data-center-location': `Carte montrant l'emplacement du centre de données`,
  },
}
  
